import { createLocaleConfig } from "@marketing-sites/l10n/config";

export const localeConfig = createLocaleConfig({
  sourceLocale: "en-US",
  localeToPrefix: {
    "fr-FR": "fr-fr",
    "es-419": "es-la",
    "de-DE": "de-de",
    "pt-BR": "pt-br",
    "x-pseudo": "ps",
  },
  pseudoLocale: "x-pseudo",
});

// Gates the footer language links, the fallback notice and all cookie access. On at tier-1 launch.
export const LOCALE_UI_ENABLED = true;

/**
 * Interim locale dirs whose URL segment `localeConfig` does not list, so
 * `stripLocalePrefix` leaves it in the logical path and the locale router never
 * claims the prefix. `ja-jp` is the last one: Japanese translation is on hold,
 * so its two hand-translated interim pages keep serving rather than redirecting
 * to English. Delete the dir and list the locale together, never separately.
 */
export const UNLISTED_LOCALE_PREFIXES: readonly string[] = ["ja-jp"];

/**
 * Prefixes an in-app path with the locale it was served under. Unlike
 * `localizeHref`, this is not gated on the locale having launched: the caller is
 * already being served under `prefix`, so the target is reachable too. Use it
 * for navigation within a flow, not for links offered to the user.
 */
export function localePath(prefix: string, path: string): string {
  if (prefix === localeConfig.DEFAULT_PREFIX) return path;
  return path === "/" ? `/${prefix}` : `/${prefix}${path}`;
}
